/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { banquetCartModifierSchema } from "./banquetCartModifierSchema.ts";

export const banquetCartModifierRequestSchema = banquetCartModifierSchema;
